<div class="relative">
  <input
    class="max-w-[424px] desktop:max-w-[562px] rounded border-black border px-3 py-2 mb-1 tablet:mb-1.5 h-[42px] bg-white text-mobileMd tablet:text-mobileMd desktop:text-desktopMd focus:outline-none w-full"
    type="text"
    [(ngModel)]="value"
    [disabled]="disabled"
    (input)="onChange(value)"
    (focus)="onFocus()"
    (blur)="onBlur()"
    [placeholder]="placeholder()"
    [id]="id()"
    #input
  />
  @if (errorMessage() && !isFocused) {
    <p
      class="text-primaryRed absolute -bottom-1/2 left-0 text-nowrap mb-1.5 text-sm tablet:text-base"
    >
      {{ errorMessage() | scTranslate | async }}
    </p>
  }
</div>
